import { render, staticRenderFns } from "./Shed.vue?vue&type=template&id=df66dd06&scoped=true&"
import script from "./Shed.vue?vue&type=script&lang=js&"
export * from "./Shed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df66dd06",
  null
  
)

export default component.exports